module.exports = __webpack_public_path__ + "static/media/debug.14543d64.svg";